// extracted by mini-css-extract-plugin
module.exports = {"textBoxCard":"TextBox_textBoxCard__1_bVV","textarea":"TextBox_textarea__2Td25","button":"TextBox_button__3taj8"};